import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Titulo from '@components/Titulo';
import Boton from '@components/Boton';
import BotonBold from '@components/BotonBold';
import Resumen from '@components/Resumen';
import { colors } from '@styles/colors';
import LoadingOverlay from '@components/LoadingOverlay';
import StorefrontIcon from '@mui/icons-material/Storefront';

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorStyle } from '@styles/cajaContenedor';
import { cajaContenedorPrimeroStyle } from '@styles/cajaContenedorPrimero';

import { logsStoreApi, storeApi } from "@api/wp/users/userApi";
import { viewEmpresasApi } from "@api/wp/empresas/empresasApi";
import { verSaveCitaApi } from "@api/wp/agenda/confirmar/confirmarApi"
import { storeCitaEmpApi } from "@api/wp/agenda/citasemp/citasEmpApi"
import { useCita } from '@providers/citaContext';
import { LAYOUT_COMPACT_MAX_PX } from '@utils/breakpoints';

import Advertencia from '@components/Advertencia';

const textoNotaResumenConfirmar = {
  fontFamily: 'Inter',
  fontSize: '1.65vh',
  fontWeight: 400,
  lineHeight: 1.4,
  color: colors.gray700,
  textAlign: 'center',
};

const Confirmar = () => {
  const sw = 0; // Variable para modo pruebas (0: Prod, 1: Pruebas)
  const [cargando, setCargando] = useState(true); // Iniciar cargando en true para asegurar que se vea
  const [error, setError] = useState(null);
  const [tiempoRestante, setTiempoRestante] = useState(600); // 600 segundos = 10 minutos
  const [citaConfirmada, setCitaConfirmada] = useState(false);
  const [modalErrorVisible, setModalErrorVisible] = useState(false);
  const [mensajeError, setMensajeError] = useState('');
  const [modalError500Visible, setModalError500Visible] = useState(false);
  const [modalConfirmVisible, setModalConfirmVisible] = useState(false);
  const valorPago = "10";
  const location = useLocation();
  const navigate = useNavigate();
  const [datosCompletos, setDatosCompletos] = useState(null);
  const { cita, setCita } = useCita();
  const [modoRevBold, setModoRevBold] = useState(0);
  const [key_bold, setKeyBold] = useState("");
  const [clave_bold, setClave_bold] = useState("");
  const [modalBoldVisible, setModalBoldVisible] = useState(false);

  // Estado para firma de integridad y orderId (deben declararse antes de cualquier return)
  const [integritySignature, setIntegritySignature] = useState('');
  const [orderId, setOrderId] = useState('');
  const boldSavedRef = React.useRef(false);
  const boldButtonRef = React.useRef(null);
  const valorDemo = 1000

  const [isMobile, setIsMobile] = useState(window.innerWidth <= LAYOUT_COMPACT_MAX_PX);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= LAYOUT_COMPACT_MAX_PX);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const {
    ciudadId,
    ciudadNombre,
    especialidadNombre,
    oidEspecialidad,
    empresaSeleccionada,
    sedeId,
    sedeNombre,
    fecha,
    medicoSeleccionado,
    medicoNombre,
    horarioSeleccionado,
    horaSeleccionada,
    empresaArray,
    valorPreviplan,
    sku,
    nombreServicio,
    descripcion,
    documento_medico
  } = cita || location.state || {};
  const descripcionServicio = descripcion || '';

  // Validación: si no hay sesión en localStorage o es "0", redirigir a membresía
  useEffect(() => {
    const validarEstado = () => {
     
      // Si el contexto de cita está vacío, redirigir a selección de ciudad
      const citaVacia = (!cita || (typeof cita === 'object' && Object.keys(cita).length === 0)) && (!location.state || Object.keys(location.state).length === 0);
      
      if (citaVacia) {
        navigate('/home');
      }
    };

    // Validar al montar
    validarEstado();

    // Validar al recibir foco
    window.addEventListener('focus', validarEstado);
    
    return () => {
        window.removeEventListener('focus', validarEstado);
    };

  }, [cita, location.state, navigate]);

  // Generar hash y establecer orderId para monto fijo (siempre ejecuta hooks)
  useEffect(() => {
    if (!clave_bold) {
      // Si no hay clave, no podemos generar hash, así que dejamos de cargar si estaba cargando
      // Pero solo si ya intentamos cargar la clave (esto es un poco tricky con useEffects separados)
      return;
    } 
    
    const generarFirma = async () => {
       try {
          // const amount = String(Number(valorDemo || valorPreviplan || valorPago || 1111110));
          const amount = String(Number(valorPreviplan || valorPago || 1111110));
          const currency = 'COP';
          const idUsuRaw = localStorage.getItem('idUsu');
          const idUsuForOrder = idUsuRaw ? String(idUsuRaw) : '0';
          const currentOrderId = `INV-${Date.now()}-${idUsuForOrder}`;
          setOrderId(currentOrderId);
          
          const cadenaConcatenada = `${currentOrderId}${amount}${currency}${clave_bold}`;
          console.log('Generating Hash for:', cadenaConcatenada);
          const hash = await generateHash(cadenaConcatenada);
          setIntegritySignature(hash);
       } catch (error) {
          console.error("Error generando firma:", error);
          setIntegritySignature('');
       } finally {
          setCargando(false);
       }
    };

    generarFirma();
  }, [valorPreviplan, sku, clave_bold]);

  useEffect(() => {
    // Preferir datos del contexto; fallback a state de navegación
    const fuente = cita || location.state;
    if (fuente) {
      setDatosCompletos(fuente);
    }
  }, [cita, location.state]);

  // Cargar clave Bold (producción) desde empresas usando empresaNombre del contexto
  useEffect(() => {
    const cargarClaveBold = async () => {
      setCargando(true);
      try {
        const nombre = (empresaSeleccionada || "").toString().trim();
        console.log('Fetching Bold keys for company:', nombre);
        if (!nombre) {
          console.warn('No company name provided for Bold keys');
          setCargando(false);
          return;
        }
        const resp = await viewEmpresasApi({ nombre_empresa: nombre });
        const lista = resp?.result || [];
        if (Array.isArray(lista) && lista.length > 0) {
          console.log('BOLD KEYS Loaded:', { 
            mode: modoRevBold === 0 ? 'PROD' : 'DEV', 
            key: lista[0]?.key_bold_prod, 
            clave: lista[0]?.clave_bold_prod,
            keyDev: lista[0]?.key_bold_dev,
            claveDev: lista[0]?.clave_bold_dev
          });
          if (modoRevBold === 0) { // Prod
            setKeyBold(lista[0]?.key_bold_prod || "");
            setClave_bold(lista[0]?.clave_bold_prod || "");
          } else { // Dev
            setKeyBold(lista[0]?.key_bold_dev || "");
            setClave_bold(lista[0]?.clave_bold_dev || "");
          }
          // No ponemos setCargando(false) aquí porque esperamos a que se genere el hash
        } else {
           // Si no se encuentra empresa, terminamos carga
           setCargando(false);
        }
      } catch (err) {
        console.error("Error consultando empresas para clave Bold:", err);
        setCargando(false);
      }
    };
    cargarClaveBold();
  }, [empresaSeleccionada]);

  // Guardar datos automáticamente cuando se genere la firma (para asegurar que el webhook encuentre los datos)
  useEffect(() => {
    if (integritySignature && !boldSavedRef.current) {
       //const valor = valorDemo || valorPreviplan || valorPago;
       const valor = valorPreviplan || valorPago;
    }
  }, [integritySignature]);

  // Efecto para el contador de tiempo
  useEffect(() => {
    if (tiempoRestante > 0 && !citaConfirmada) {
      const timer = setTimeout(() => {
        setTiempoRestante(tiempoRestante - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (tiempoRestante === 0 && !citaConfirmada) {
      alert('Proceso frenado');
      // Redirigir a la página principal sin state
      navigate('/');
    }
  }, [tiempoRestante, citaConfirmada, navigate]);

  /** Estado para pantalla Final tras pago en ventanilla (cuenta atrás hacia Ciudad). */
  const buildEstadoFinalVentanilla = () => ({
    fromVentanillaExito: true,
    ciudadId,
    ciudadNombre,
    especialidadNombre,
    oidEspecialidad,
    empresaNombre: empresaSeleccionada,
    sedeId,
    sedeNombre,
    fecha,
    medicoSeleccionado,
    medicoNombre,
    horarioSeleccionado,
    horaSeleccionada,
    valorPreviplan,
    sku,
    nombreServicio,
    descripcion: descripcionServicio,
  });

  const confirmarCita = async (metodoPago = 'ventanilla') => {
    setCargando(true);
    setError(null);
    setCitaConfirmada(true); // Marcar que se está confirmando la cita

    try {
      // Obtener datos del usuario desde localStorage
      const cedulaLS = localStorage.getItem('cedula');
      let numeroDocumento = '';
      try {
        const parsed = JSON.parse(cedulaLS);
        numeroDocumento = (parsed ?? '').toString();
      } catch (e) {
        numeroDocumento = (cedulaLS ?? '').toString();
      }
      //console.log('numeroDocumento ', numeroDocumento)
      const idUsu = localStorage.getItem('idUsu');
      
      if (sw == 1) {
        const dataLocal = {
          fecha: fecha,
          oid_especialidad: oidEspecialidad,
          id_paciente: idUsu,
          requestId: "--",
          CitaID: 1,
          metodo: metodoPago,
          empresa: empresaSeleccionada,
          oid_sede: sedeId,
          order_id: metodoPago === 'bold' ? orderId : "-",
          transaccion_pago: metodoPago === 'bold' ? orderId : "-",
          numero_documento: numeroDocumento,
          oid_medico: medicoSeleccionado,
          hora: horaSeleccionada,
          nombre_espe: especialidadNombre,
          nombre_sede: sedeNombre,
          valor: valorPreviplan,
          iden_medico: documento_medico
        }
        console.log('SALVAR STORE LOCAL - 1', dataLocal)
        // Guardar logs 
        const response = await storeApi(dataLocal);

        if (response && response.statusCode === 201) {
          console.log('Cita guardada exitosamente:', response);
          
          if (metodoPago === 'bold') {
             // Si es Bold, lanzamos el checkout y NO limpiamos cita ni mostramos éxito aún
             // El éxito dependerá del webhook o redirección de Bold
             try {
               const snap = {
                 ...(cita || {}),
                 ciudadId,
                 ciudadNombre,
                 especialidadNombre,
                 oidEspecialidad,
                 empresaNombre: empresaSeleccionada,
                 sedeId,
                 sedeNombre,
                 fecha,
                 medicoSeleccionado,
                 medicoNombre,
                 horarioSeleccionado,
                 horaSeleccionada,
                 valorPreviplan,
                 sku,
                 nombreServicio,
               };
               sessionStorage.setItem('previsalud_final_cita_bold', JSON.stringify(snap));
             } catch (_) {
               /* noop */
             }
             if (boldButtonRef.current && boldButtonRef.current.openCheckout) {
                boldButtonRef.current.openCheckout();
             }
             setCargando(false); // Dejamos de cargar para que el usuario pueda interactuar con Bold
             return; 
          }
          navigate('/final', { replace: true, state: buildEstadoFinalVentanilla() });
        } else {
          setMensajeError('Error inesperado al guardar la cita');
          setModalErrorVisible(true);
          return;
        }

      } else {
        let fechaFormateada = fecha;
        if (fecha && fecha.includes('-')) {
          const [year, month, day] = fecha.split('-');
          fechaFormateada = `${year}/${month}/${day}`;
        }

        const data = {
          empresa: empresaSeleccionada,
          oid_sede: sedeId,
          oid_tipo_documento: 1,
          numero_documento: numeroDocumento,
          oid_especialidad: oidEspecialidad,
          oid_medico: medicoSeleccionado,
          fecha: fechaFormateada,
          hora: horaSeleccionada
        }
        console.log('SALVAR CITA PREVIS ', data)
        const response = await verSaveCitaApi(data);
        console.log('data response ', response)
        if (response.code == 200) {
          const dataLocal = {
            fecha: fecha,
            oid_especialidad: oidEspecialidad,
            id_paciente: idUsu,
            requestId: response.requestId,
            CitaID: response?.data?.CitaID,
            empresa: empresaSeleccionada,
            oid_sede: sedeId,
            metodo: metodoPago,
            order_id: metodoPago === 'bold' ? orderId : "-",
            transaccion_pago: metodoPago === 'bold' ? orderId : "-",
            numero_documento: numeroDocumento,
            oid_medico: medicoSeleccionado,
            hora: horaSeleccionada,
            nombre_espe: especialidadNombre,
            nombre_sede: sedeNombre,
            valor: valorPreviplan,
            iden_medico: documento_medico
          }
          console.log( 'DATAA RESPONS CITA' ,dataLocal) 
          const responseStore = await storeApi(dataLocal);
          if (responseStore && responseStore.statusCode === 201) {
            
            if (metodoPago === 'bold') {
                try {
                  const snap = {
                    ...(cita || {}),
                    ciudadId,
                    ciudadNombre,
                    especialidadNombre,
                    oidEspecialidad,
                    empresaNombre: empresaSeleccionada,
                    sedeId,
                    sedeNombre,
                    fecha,
                    medicoSeleccionado,
                    medicoNombre,
                    horarioSeleccionado,
                    horaSeleccionada,
                    valorPreviplan,
                    sku,
                    nombreServicio,
                  };
                  sessionStorage.setItem('previsalud_final_cita_bold', JSON.stringify(snap));
                } catch (_) {
                  /* noop */
                }
                if (boldButtonRef.current && boldButtonRef.current.openCheckout) {
                   boldButtonRef.current.openCheckout();
                }
                setCargando(false);
                return;
            }
            navigate('/final', { replace: true, state: buildEstadoFinalVentanilla() });
          } else {
            setMensajeError('Error al guardar la cita en base de datos local');
            setModalErrorVisible(true);
            return;
          }

        }
        if (response.code == 400) {
          // Mostrar modal de error para agenda no disponible
          setMensajeError(response.message || 'No se cuenta con agenda disponible');
          setModalErrorVisible(true);
          setCargando(false);
          return;
        }
        if (response.code == 409) {
          // Mostrar modal de error para agenda no disponible
          setMensajeError(response.message || 'No se cuenta con agenda disponible');
          setModalErrorVisible(true);
          setCargando(false);
          return;
        }
        if (response.code == 408) {
          // Mostrar modal de error para agenda no disponible
          setMensajeError(response.message || 'No se pudo conectar al servidor');
          setModalErrorVisible(true);
          setCargando(false);
          return;
        }
      }
    } catch (error) {
      console.error('Error al guardar cita:', error);
      
      // Enviar log de error a agendawpServices
      try {
        const logData = {
          requestId: error.requestId || '0',
          message: error.message || JSON.stringify(error)
        };
        await logsStoreApi(logData);
      } catch(e) { 
        console.error('Error enviando log:', e); 
      }

      // Manejo de conflicto (409) - Doble reserva
      if (error.statusCode === 409 || error.code === 409) {
        setMensajeError(error.message || 'Lo sentimos, el horario seleccionado ya ha sido reservado por otro usuario.');
        setModalErrorVisible(true);
        setCargando(false);
        return;
      }

      if (error.code === 500 || error.statusCode === 500) {
        // Mostrar modal de error para usuario no Previplan
        setModalError500Visible(true);
        setCargando(false);
        return;
      }

      setMensajeError(error.message || 'Error al procesar la solicitud');
      setModalErrorVisible(true);
      setCargando(false);
    } finally {
      if (metodoPago !== 'bold') {
         setCargando(false);
      }
    }
  };
  if (!datosCompletos) {
    return (
      <div style={cajaPrincipalStyle}>
        <div>Cargando datos de la cita...</div>
      </div>
    );
  }

  // Función asincrónica para generar el hash SHA-256
  async function generateHash(cadena) {
    // Codificar la cadena en UTF-8
    const encodedText = new TextEncoder().encode(cadena);

    // Generar el hash SHA-256
    const hashBuffer = await crypto.subtle.digest('SHA-256', encodedText);

    // Convertir el buffer del hash en un array de bytes
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // Convertir cada byte en una representación hexadecimal y unirlos en una sola cadena
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

    return hashHex;
  }



  return (
    <div id="cajaPrincipal" style={cajaPrincipalStyle}>
      <Titulo
        titulo="Pago del servicio"
        imagen_titulo="Confirma y paga"
        subtitulo="Revisa el resumen de tu cita y selecciona el método de pago."
        rutaRetorno="/agenda/horas"
        stateRetorno={{
          ciudadId: ciudadId,
          ciudadNombre: ciudadNombre,
          especialidadNombre: especialidadNombre,
          oidEspecialidad: oidEspecialidad,
          sedeId: sedeId,
          sedeNombre: sedeNombre,
          empresaNombre: empresaSeleccionada,
          empresaArray: empresaArray,
          horarioSeleccionado: horarioSeleccionado,
          horaSeleccionada: horaSeleccionada,
          medicoSeleccionado: medicoSeleccionado,
          fecha
        }}
        resumenAgendaProps={{
          ciudad: ciudadNombre,
          servicio: especialidadNombre,
          ubicacion: sedeNombre,
          fecha,
          medico: medicoNombre,
          hora: horaSeleccionada,
          nomServicio: nombreServicio,
          descripcion: descripcionServicio,
        }}
      />

      <LoadingOverlay visible={cargando} />

      {/* Div central */}
      <div style={{...cajaContenedorStyle, ...(isMobile && { marginLeft: '0', width: '100%', padding: '0 2vh', boxSizing: 'border-box' })}}>
        {/* Primer div */}

        {/* Contenido del primer div */}
        <div style={{...cajaContenedorPrimeroStyle, ...(isMobile && { width: '100%', marginLeft: '0', display: 'flex', flexDirection: 'column', alignItems: 'center' })}}>

          {/* Nuevo div con especificaciones solicitadas */}
          <div id="citaConfirmar" style={{
            width: isMobile ? '100%' : '85.4vh',
            height: isMobile ? 'auto' : '55vh',
            transform: 'rotate(0deg)',
            opacity: 1,
            position: isMobile ? 'relative' : 'absolute',
            left: isMobile ? 'auto' : '47.2vh',
            marginTop: isMobile ? '2vh' : '0',
            borderRadius: '2.706vh',
            backgroundColor: colors.gray150,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: '2.5vh',
            padding: '3vh',
            boxSizing: 'border-box'
          }}>
            {/* Contador de tiempo */}
            {!citaConfirmada && (
              <div style={{
                textAlign: 'center',
                margin: 0,
                padding: '1.25vh 1vh',
                backgroundColor: tiempoRestante <= 3 ? colors.naranja : colors.naranja,
                borderRadius: '1vh',
                border: 'none',
                width: '100%',
                boxSizing: 'border-box'
              }}>
                <span style={{
                  fontSize: '2vh',
                  fontFamily: 'Inter',
                  fontWeight: '600',
                  color: tiempoRestante <= 10 ? colors.errorText : colors.white
                }}>
                  Tiempo restante para realizar el pago:
                  <img
                    src="/reloj.png"
                    alt="Reloj"
                    style={{
                      width: '2.2vh',
                      height: '2.2vh',
                      margin: '0 0.8vh',
                      verticalAlign: 'middle'
                    }}
                  />
                  {Math.floor(tiempoRestante / 60)}:{(tiempoRestante % 60).toString().padStart(2, '0')}
                </span>
              </div>
            )}
            <div id="cajaServicio" style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5vh',
              width: '100%',
              margin: 0,
              marginTop:30,
              fontFamily: 'Inter',
              fontSize: '18px',
              fontWeight: '700',
              color: colors.primaryText,
              textAlign: 'center',
              boxSizing: 'border-box',
            }}>
              {nombreServicio || 'No seleccionada'}
            </div>
            <div id="cajaValorServ" style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5vh',
              width: '100%',
              margin: 0,
              marginTop:5,
              fontFamily: 'Inter',
              fontSize: '32px',
              color: colors.primaryText,
              textAlign: 'center',
              boxSizing: 'border-box',
            }}>
              <div>{valorPreviplan ? `$${Number(valorPreviplan).toLocaleString()}` : 'No disponible'}</div>
            </div>

            {(sw === 1) && (
              <div style={{
                color: sw === 1 ? colors.errorText : colors.success,
                fontSize: '1.8vh',
                fontFamily: 'Inter',
                fontWeight: 600,
                textAlign: 'center',
                padding: '1vh',
                border: `1px solid ${sw === 1 ? colors.errorText : colors.success}`,
                borderRadius: '8px',
                backgroundColor: sw === 1 ? colors.errorShadow : colors.successBg,
                margin: 0,
                width: '100%',
                boxSizing: 'border-box',
              }}>
                {sw === 1 ? 'Desarrollo' : 'Producción'}
              </div>
            )}

            <div style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'stretch' : 'center',
              justifyContent: 'center',
              gap: '2vh',
              margin: 0,
              marginTop:5,
              width: '100%',
              boxSizing: 'border-box',
            }}>
              {/* Botón de pagos BOLD */}
              <div style={{ width: isMobile ? '100%' : 'auto', display: 'flex', justifyContent: 'center' }}>
                <BotonBold 
                  ref={boldButtonRef}
                  integritySignature={integritySignature}
                  onClick={() => setModalBoldVisible(true)}
                  apiKey={key_bold}
                  orderId={orderId}
                  amount={String(Number( valorPreviplan || valorPago))}
                  description={nombreServicio}
                  disabled={cargando || modalBoldVisible || modalConfirmVisible}
                  ancho={isMobile ? '100%' : '26.5vh'}
                  redirectionUrl={`${window.location.origin}/final`}
                />
              </div>
              
              <button
                type="button"
                onClick={() => setModalConfirmVisible(true)}
                disabled={cargando || modalBoldVisible || modalConfirmVisible}
                style={{
                  width: isMobile ? '100%' : "26.5vh",
                  height: "6.5vh",
                  boxSizing: 'border-box',
                  backgroundColor: (cargando || modalBoldVisible || modalConfirmVisible) ? colors.gray400 : colors.verdeClaro,
                  borderRadius: '2.8vh',
                  transform: 'rotate(0deg)',
                  opacity: (cargando || modalBoldVisible || modalConfirmVisible) ? 0.6 : 1,
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '1vh',
                  fontSize: '1.9vh',
                  fontFamily: 'Inter',
                  color: colors.primaryText,
                  cursor: (cargando || modalBoldVisible || modalConfirmVisible) ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                }}>
                <span style={{ fontWeight: 600 }}>
                  {cargando ? "Guardando..." : "Pagar en ventanilla"}
                </span>
                <StorefrontIcon sx={{
                  fontSize: '2.5vh',
                  color: (cargando || modalBoldVisible || modalConfirmVisible) ? colors.gray600 : colors.primaryText,
                }} />
              </button>
            </div>
            <div
              style={{
                ...textoNotaResumenConfirmar,
                width: '100%',
                margin: 0,
                padding:5,
                boxSizing: 'border-box',
              }}
            >
              TEN EN CUENTA QUE SI CANCELAS O INTERRUMPES EL PROCESO DE PAGO, PODRÁS REINTENTAR EL PAGO DESDE &quot;SOLICITAR O HISTORIAL DE CITAS&quot;
            </div>
            {modoRevBold === 1 && (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                margin: 0,
                boxSizing: 'border-box',
              }}>
                <div style={{
                  backgroundColor: colors.errorBg,
                  border: `2px solid ${colors.error}`,
                  color: colors.errorText,
                  borderRadius: '1vh',
                  padding: '1.2vh 1.6vh',
                  fontFamily: 'Inter',
                  fontSize: '2vh',
                  fontWeight: 700,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1vh'
                }}>
                  <span style={{ fontSize: '2.2vh' }}>⚠️</span>
                  <span>Modo desarrollo Bold</span>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Fin contenido del primer div */}

        {!isMobile && <Resumen ciudad={ciudadNombre} servicio={especialidadNombre} ubicacion={sedeNombre} fecha={fecha} medico={medicoNombre} hora={horaSeleccionada} nomServicio={nombreServicio} descripcion={descripcionServicio} /> }

      </div>

      {/* Modal de Confirmación Bold */}
      {modalBoldVisible && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1001
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '2vh',
            padding: '4vh',
            maxWidth: '80vh',
            width: '90%',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
            textAlign: 'center',
            fontFamily: 'Inter'
          }}>
            <h2 style={{
              color: colors.primaryText,
              fontSize: '2.4vh',
              fontWeight: 'bold',
              marginBottom: '2vh',
              margin: 0
            }}>
              ¿Está seguro que desea realizar el agendamiento?
            </h2>
            <div style={{ display: 'flex', gap: '2vh', justifyContent: 'center', marginTop: '2vh' }}>
              <Boton
                label="Sí, pagar"
                onClick={() => { 
                    setModalBoldVisible(false); 
                    confirmarCita('bold');
                }}
              />
              <Boton
                label="Cancelar"
                onClick={() => setModalBoldVisible(false)}
                color={colors.gray600}
              />
            </div>
          </div>
        </div>
      )}

      {/* Modal de confirmación */}
      {modalConfirmVisible && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '2vh',
            padding: '4vh',
            maxWidth: '80vh',
            width: '90%',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
            textAlign: 'center',
            fontFamily: 'Inter'
          }}>
            <h2 style={{
              color: colors.primaryText,
              fontSize: '2.4vh',
              fontWeight: 'bold',
              marginBottom: '2vh',
              margin: 0
            }}>
              ¿Está seguro que desea realizar el agendamiento?
            </h2>
            <div style={{ display: 'flex', gap: '2vh', justifyContent: 'center', marginTop: '2vh' }}>
              <Boton
                label="Sí, confirmar"
                onClick={() => { setModalConfirmVisible(false); confirmarCita(); }}
              />
              <Boton
                label="No, cancelar"
                onClick={() => setModalConfirmVisible(false)}
                color={colors.gray600}
              />
            </div>
          </div>
        </div>
      )}

      {/* Modal de error */}
      {modalErrorVisible && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '2vh',
            padding: '4vh',
            maxWidth: '80vh',
            width: '90%',
            textAlign: 'center',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <Advertencia mensaje={mensajeError || "Ocurrió un error inesperado"} ancho="100%" />

            {/* Botones */}
            <div style={{
              display: 'flex',
              gap: '2vh',
              justifyContent: 'center',
              marginTop: '3vh'
            }}>
              <Boton
                label="Aceptar"
                onClick={() => {
                  setModalErrorVisible(false);
                }}
                ancho="20vh"
                alto="5vh"
              />
            </div>
          </div>
        </div>
      )}

      {/* Modal de Error 500 - Usuario no Previplan */}
      {modalError500Visible && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '4vh',
            borderRadius: '2vh',
            maxWidth: '80%',
            maxHeight: '80%',
            overflow: 'auto',
            textAlign: 'center',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            {/* Icono de error */}
            <div style={{
              fontSize: '8vh',
              marginBottom: '2vh'
            }}>
              ⚠️
            </div>

            {/* Título */}
            <h2 style={{
              color: colors.errorText,
              marginBottom: '2vh',
              fontSize: '3vh',
              fontWeight: 'bold',
              fontFamily: 'Inter'
            }}>
              Usuario no válido
            </h2>

            {/* Mensaje */}
            <p style={{
              marginBottom: '3vh',
              fontSize: '2.2vh',
              lineHeight: '1.5',
              color: colors.gray700,
              fontWeight: 'bold',
              fontFamily: 'Inter'
            }}>
              No eres usuario Previplan. Por favor valida tu información o reporta este error.
            </p>

            {/* Botones */}
            <div style={{
              display: 'flex',
              gap: '2vh',
              justifyContent: 'center'
            }}>
              <Boton
                label="Aceptar"
                onClick={() => {
                  setModalError500Visible(false);
                }}
                ancho="25vh"
                alto="5vh"
              />
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Confirmar;
